// 色の連動（2026-10-21 に app.js から分けた）
import { S } from './state.js';
import { C } from './core/model.js';
import { catByKey } from './store.js';
import { keyOf } from './util.js';
import type { Category } from './types.js';
import { CONFIG } from './config.js';
// ---- 色の連動（同じ色にまとめて付けるカテゴリ） ----
// 本物はデータの GROUP で決まっている（skin: からだ・かお、hair: まゆ・髪 1〜3。髪 4・髪 5 は入っていない。chibi.getGroupCategory）。
// モックは使う人が選べる: 塗り方が同じもの同士（グラデーションの髪とまゆ = hair、肌 = skin）の中で、連動させるカテゴリを入れたり外したりする。
// はじめはデータの GROUP と同じ。選んだものはキャラではなく、このブラウザの使い方の好みとして残す（charatCreate.links）。
// 保存データはカテゴリごとの色のままなので、本物でもそのまま出る（同じグループで色が違っても、本物は読み込み・保存とも行ごとの色を使う。2026-10-11 に確認）
export const LINK_KEY = 'charatCreate.links';
// DRESSUP2 は髪にグラデーションが無く、データのグループ（GROUP hair: 前髪・後ろ髪・横髪・ポニーテール・アホ毛・まゆ）で決める（設定 linkHair、2026-10-28 ユーザー依頼）
export function linkFamily(cat: Category | undefined): 'hair' | 'skin' | null {
  if (!cat || cat.NAME === 'chara') return null;
  if (cat.GRAD.length > 1) return 'hair';
  if (CONFIG.linkHair === 'group' && cat.GROUP === 'hair') return 'hair';
  if (cat.GROUP === 'skin') return 'skin';
  return null;
}
export function familyCats(fam: string | null) { return C.cats.filter((c) => linkFamily(c) === fam); }
export function defaultLinks() {
  const out: Record<string, string[]> = {};
  ['hair', 'skin'].forEach((fam) => {
    const want = CONFIG.linkDefault && CONFIG.linkDefault[fam];
    out[fam] = familyCats(fam).filter((c) => (want ? want.indexOf(keyOf(c)) >= 0 : c.GROUP && c.GROUP === fam)).map(keyOf);
  });
  return out;
}
export function loadLinks(): Record<string, string[]> {
  if (S.links) return S.links;
  S.links = defaultLinks();
  try {
    const o = JSON.parse(localStorage.getItem(LINK_KEY) || 'null');
    ['hair', 'skin'].forEach((fam) => {
      // 保存場所はメーカーで共通。ほかのメーカーのカテゴリしか無い（このメーカーで選んだことが無い）ときは、はじめのまま
      if (!o || !Array.isArray(o[fam])) return;
      const mine = o[fam].filter((k: string) => linkFamily(catByKey[k]) === fam);
      if (mine.length || !o[fam].length) S.links![fam] = mine;
    });
  } catch (e) { /* はじめのまま */ }
  return S.links;
}
export function saveLinks() { try { localStorage.setItem(LINK_KEY, JSON.stringify(S.links)); } catch (e) { /* 残せなくても動く */ } }
export function isLinked(cat: Category) {
  const fam = linkFamily(cat);
  return !!fam && loadLinks()[fam].indexOf(keyOf(cat)) >= 0 && loadLinks()[fam].length > 1;
}
export function groupOf(cat: Category): Category[] {
  // 連動しているカテゴリにまとめて付ける（はじめは chibi.getGroupCategory と同じ）
  if (!isLinked(cat)) return [cat];
  const set = loadLinks()[linkFamily(cat)!];
  return C.cats.filter((c) => set.indexOf(keyOf(c)) >= 0);
}
